import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginFaqsComponent } from '@core-app/layout/login-faqs/login-faqs.component';
import { ActivateComponent } from '@core-app/layout/login/activate.component';
import { LoginComponent } from '@core-app/layout/login/login.component';
import { MainComponent } from '@core-app/layout/main/main.component';
import { MaintenanceComponent } from '@core-app/layout/maintenance/maintenance.component';
import { OopsComponent } from '@core-app/layout/oops/oops.component';
import { PostComponent } from '@core-app/layout/post/post.component';
import { RegisterComponent } from '@core-app/layout/register/register.component';
import { ResetConfirmComponent } from '@core-app/layout/reset/reset-confirm.component';
import { ResetRequestComponent } from '@core-app/layout/reset/reset-request.component';
import { ClientService } from '@core-app/services/client.service';
import { PageComponent, PreviewComponent } from '@gallaghercp/core-frontend';
import { LayoutModule } from './layout/layout.module';

export const routes: Routes = [
  {
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  {
    path: '404',
    pathMatch: 'full',
    component: OopsComponent,
  },
  {
    path: 'preview',
    component: MainComponent,
    children: [
      {
        path: '',
        component: PreviewComponent,
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    redirectTo: '/',
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [ClientService],
    children: [
      {
        path: '',
        component: PageComponent,
      },
      {
        path: ':identifier',
        component: PageComponent,
      },
      {
        path: 'articles',
        children: [
          {
            path: ':identifier',
            component: PostComponent,
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [
    LayoutModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
